<template>
  <div class="fitbar-floating-actions">
    <!-- Botón Flotante Elegante de WhatsApp con Tooltip -->
    <a
      href="https://api.whatsapp.com/send?phone=9983641651&text=%C2%A1Hola%20The%20Fit%20Bar!%20%F0%9F%8D%BD%EF%B8%8F%20Quiero%20hacer%20un%20pedido."
      target="_blank"
      rel="noopener noreferrer"
      class="floating-whatsapp-pill shadow-lg d-inline-flex align-items-center"
      title="Pedir por WhatsApp"
    >
      <div class="whatsapp-circle-icon">
        <i class="bi bi-whatsapp"></i>
      </div>
      <div class="whatsapp-label d-none d-sm-flex flex-column text-start pe-2">
        <span class="ordena-title">ORDENA AQUÍ</span>
        <span class="chat-subtitle">CHAT DIRECTO</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "Botones_flotantes",
};
</script>

<style scoped>
.fitbar-floating-actions {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1040;
}

.floating-whatsapp-pill {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  color: #ffffff !important;
  text-decoration: none !important;
  padding: 8px 24px 8px 8px;
  border-radius: 50px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  gap: 12px;
}

.floating-whatsapp-pill:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 14px 35px rgba(37, 211, 102, 0.65) !important;
  color: #ffffff !important;
}

.whatsapp-circle-icon {
  width: 54px;
  height: 54px;
  background-color: #ffffff;
  color: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.85rem;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
}

.whatsapp-label {
  color: #ffffff;
  line-height: 1.15;
}

.ordena-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.12rem;
  font-weight: 900;
  letter-spacing: 0.6px;
  color: #ffffff;
  display: block;
}

.chat-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.88rem;
  font-weight: 800;
  color: #fffb91;
  letter-spacing: 0.8px;
  display: block;
}

@media (max-width: 575px) {
  .fitbar-floating-actions {
    bottom: 18px;
    right: 18px;
  }
  .floating-whatsapp-pill {
    padding: 6px;
    gap: 0;
  }
  .whatsapp-circle-icon {
    width: 52px;
    height: 52px;
    font-size: 1.75rem;
  }
}
</style>
